import React from 'react';
import './Page.css';

const TermsConditions = () => {
  return (
    <div className="page-content">
      <div className="container">
        <h1>Terms and Conditions</h1>
        
        <h2>Who We Are and How to Contact Us</h2>
        <p>These terms and conditions ("Terms" or "Agreement") govern your use of the Services (as defined below) provided by QuantumSync s.r.o. C 388554, a company incorporated under the laws of the Czech Republic, with a registered office at Cimburkova 916/8, Žižkov, 130 00 Praha 3, Czech Republic ("Quantum Sync", "Company", "we", "us", or "our").</p>
        
        <p>To reach us, please email: <a href="mailto:info@quantumsync.tech">info@quantumsync.tech</a></p>
        
        <h2>By Using Our Site, You Accept These Terms and Conditions</h2>
        <p>By activating your Quantum Sync Account (as defined below), you confirm that you have read, understood, and agree to these Terms. We recommend printing a copy of these Terms for your records and checking this page regularly for any updates.</p>
        
        <h2>Digital Currency Risks and Acknowledgment</h2>
        <p>Digital Currency is primarily used by speculators and can be highly volatile. Its prices fluctuate throughout the day without limits or protections, influenced by market makers, global governmental policies, regulators, and public sentiment. You acknowledge and understand that investing in Digital Currency may lead to significant or total loss of your investment.</p>
        
        <h2>Important Notice</h2>
        <div className="warning-box">
          <p><strong>We will NEVER ask you to send us your user ID, online password, online PIN, or mobile PIN via email.</strong></p>
          <p>We or our affiliated companies will NEVER request your full user ID, online password, online PIN, or mobile PIN for identification over the phone.</p>
        </div>
        
        <p>We do not hold any Fiat Currency on your behalf; we only hold Digital Currency.</p>
        
        <h2>Additional Terms</h2>
        <p>These Terms also cover:</p>
        <ul>
          <li>Managing Your Quantum Sync Account</li>
          <li>Termination and Suspension</li>
          <li>Liability</li>
          <li>Governing Law and Jurisdiction</li>
        </ul>
      </div>
    </div>
  );
};

export default TermsConditions;
